import React, { Component, Fragment } from 'react'
import "react-step-progress-bar/styles.css";
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import {ProgressBar, Step} from "react-step-progress-bar";
import LoadMask from "../../../Utils/LoadMask/LoadMask";
import PasoUnoForm from "./ClienteForm";
import PasoDosForm from "./facturacionForm";
import PasoTresForm from "./contactoForm";
import PasoCuatroForm from './sucursalesForm';
import PasoCincoForm from "./cuantaForm";
import PasoSeisForm from "./cuentaCPP";

export default class ClienteCrear extends Component{
    state ={
        editar:false,
        step:1,
        es_cliente: 2,
        titulo: "REGISTRAR CLIENTE",
        route: "/clientes",
        cpp: true,
        municipios: []
    };
    componentDidMount(){
        this.props.limpiarItem()
        this.props.selectRegiones()
        this.props.selectEmpresas()
        if (this.props.location.state){
            this.setState({
                es_cliente:1,
                titulo: "REGISTRAR PROVEEDOR",
                route:"/proveedores"
            })
            if (this.props.match.params.id){
                this.props.leer(this.props.match.params.id, "");
                this.setState({editar:true});
            }

        }else if (this.props.match.params.id){
            this.props.leer(this.props.match.params.id, true);
            this.setState({editar:true});
        }
    }
    nextStep = () => {
        this.setState({ step: this.state.step + 1 })
    };

    previousStep =() => {
        this.setState({ step: this.state.step - 1 })
    };

    handleSubmit = (values) =>{
        values.tipo = this.state.es_cliente;
        const {crear, editar} =this.props
        let id = this.props.match.params.id;
        let Clipro= this.state.es_cliente;
        this.state.editar? editar(id,values,Clipro, this.props.facturacion_ref) : crear(values,Clipro, this.props.facturacion_ref);
    }
    render(){
        const {loader, municipios_bancos, AddMunicipio, ChangeMunicipio, controles, item,
            empresas, setEmpresasForm, setEmpresasFormProvedor, validateNit, setDataName, changeFieldClienteForm, getFieldClienteFormFacturacion, loaderComponet
        } = this.props;
        const{step}=this.state;
        let permiso_cuenta = false
        if (!!item && !!item.es_actualizado){
            permiso_cuenta = false
        }
        else{permiso_cuenta=true;}

        return(
            <div className="Container">
                <div className="row">
                    <div className="mb-4 col-12">
                        <div className="mb-4 card card-small m-t">
                            <div className="card-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-10 col-sm-10 col-12">
                                        <ProgressBar
                                            percent={
                                                permiso_cuenta ? (
                                                    step === 1 ? 0: step === 2 ? 18 : step === 3 ? 36 :step === 4 ? 54 :step === 5 ? 72:step === 6 && 90
                                                ):(
                                                    step === 1 ? 0: step === 2 ? 20 : step === 3 ? 45 :step === 4 ? 65 : 85
                                                )
                                            }
                                            filledBackground= "#f3a631"
                                            stepPositions={ permiso_cuenta ? [0,18,36,54,72,90]:[0,20,45,65,85,85] }
                                        >
                                            <Step transition="scale">
                                                {({ accomplished, index }) => (
                                                    <div
                                                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                    >
                                                        <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                            1
                                                        </div>
                                                    </div>
                                                )}
                                            </Step>
                                            <Step transition="scale" position="50%">
                                                {({ accomplished, index }) => (
                                                    <div
                                                    style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                    >
                                                        <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                            2
                                                        </div>
                                                    </div>
                                                )}
                                            </Step>
                                            <Step transition="scale" position="50%">
                                                {({ accomplished, index }) => (
                                                    <div
                                                    style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                    >
                                                        <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                          3
                                                        </div>
                                                    </div>
                                                )}
                                            </Step>
                                            <Step transition="scale">
                                                {({ accomplished, index }) => (
                                                    <div
                                                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                    >
                                                        <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                            4
                                                        </div>
                                                    </div>
                                                )}
                                            </Step>
                                            <Step transition="scale">
                                                {({ accomplished, index }) => (
                                                    <div
                                                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                    >
                                                        <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                            5
                                                        </div>
                                                    </div>
                                                )}
                                            </Step>
                                            {
                                                (<Step transition="scale">
                                                    {({ accomplished, index }) => (
                                                        <div
                                                            style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                                                        >
                                                            <div className={ `${accomplished? 'step-caption-selected':"step-caption"}`}>
                                                                { permiso_cuenta?  "6":"5"}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Step>)
                                            }
                                        </ProgressBar>
                                    </div>
                                </div>
                                <div className="p-0 px-3 pt-3">
                                    <LoadMask loading={loader} light>
                                        {
                                            this.state.editar ?
                                                (<Fragment>
                                                    {step === 1 && (
                                                        <PasoUnoForm
                                                            getMunicipios={this.props.setMunicipios}
                                                            municipios={this.props.municipios}
                                                            regiones={this.props.regiones}
                                                            onSubmit={this.nextStep}
                                                            route={this.state.route}
                                                            titulo={this.state.titulo}
                                                            es_cliente={this.state.es_cliente}
                                                            editar={this.state.editar}
                                                        />
                                                    )}
                                                    {step === 2 && (
                                                        <PasoDosForm
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                            validateNit={validateNit}
                                                            setDataName={setDataName}
                                                            changeFieldClienteForm = {changeFieldClienteForm}
                                                            getFieldClienteFormFacturacion = {getFieldClienteFormFacturacion}
                                                            isLoadre={loaderComponet}
                                                            facturacion_ref={this.props.facturacion_ref}
                                                        />
                                                    )}
                                                    {step === 3 && (
                                                        <PasoTresForm
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                        />
                                                    )}
                                                    {step === 4 && (
                                                        <PasoCuatroForm
                                                            ChangeMunicipio={ChangeMunicipio}
                                                            AddMunicipio={AddMunicipio}
                                                            municipios_bancos={municipios_bancos}
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                            controles={controles}
                                                            es_cliente={ this.state.es_cliente}
                                                        />
                                                    )}
                                                    {step === 5 && (
                                                        <PasoCincoForm
                                                            onSubmit={permiso_cuenta ?  this.nextStep:this.handleSubmit}
                                                            previousStep={this.previousStep}
                                                            permiso_cuenta={permiso_cuenta}
                                                        />
                                                    )}
                                                    { permiso_cuenta && (step === 6 && (
                                                        <PasoSeisForm
                                                            onSubmit={this.handleSubmit}
                                                            previousStep={this.previousStep}
                                                            setEmpresasForm={setEmpresasForm}
                                                            setEmpresasFormProvedor={setEmpresasFormProvedor}
                                                            empresas={empresas}
                                                            es_cliente={ this.state.es_cliente}
                                                        />
                                                    ))}


                                                </Fragment>):
                                                (<Fragment>
                                                    {step === 1 && (
                                                        <PasoUnoForm
                                                            getMunicipios={this.props.setMunicipios}
                                                            municipios={this.props.municipios}
                                                            regiones={this.props.regiones}
                                                            onSubmit={this.nextStep}
                                                            route={this.state.route}
                                                            titulo={this.state.titulo}
                                                            es_cliente={this.state.es_cliente}
                                                            editar={this.state.editar}
                                                            permiso_cuenta={permiso_cuenta}
                                                            setEmpresasForm={setEmpresasForm}
                                                        />
                                                    )}
                                                    {step === 2 && (
                                                        <PasoDosForm
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                            validateNit={validateNit}
                                                            setDataName={setDataName}
                                                            changeFieldClienteForm = {changeFieldClienteForm}
                                                            getFieldClienteFormFacturacion = {getFieldClienteFormFacturacion}
                                                            isLoadre={loaderComponet}
                                                            facturacion_ref={this.props.facturacion_ref}
                                                        />
                                                    )}
                                                    {step === 3 && (
                                                        <PasoTresForm
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                        />
                                                    )}
                                                    {step === 4 && (
                                                        <PasoCuatroForm
                                                            ChangeMunicipio={ChangeMunicipio}
                                                            AddMunicipio={AddMunicipio}
                                                            municipios_bancos={municipios_bancos}
                                                            onSubmit={this.nextStep}
                                                            previousStep={this.previousStep}
                                                            controles={controles}
                                                            es_cliente={ this.state.es_cliente}
                                                        />
                                                    )}
                                                    {step === 5 && (
                                                        <PasoCincoForm
                                                        onSubmit={permiso_cuenta ?  this.nextStep:this.handleSubmit}
                                                        previousStep={this.previousStep}
                                                        permiso_cuenta={permiso_cuenta}

                                                        />
                                                    )}
                                                    {permiso_cuenta && (step === 6 && (
                                                        <PasoSeisForm
                                                            onSubmit={this.handleSubmit}
                                                            previousStep={this.previousStep}
                                                            setEmpresasForm={setEmpresasForm}
                                                            setEmpresasFormProvedor={setEmpresasFormProvedor}
                                                            empresas={empresas}
                                                            es_cliente={ this.state.es_cliente}

                                                        />
                                                    ))}
                                                </Fragment>
                                            )
                                        }
                                    </LoadMask>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

// const selector = formValueSelector('ClientesForm');
// Empresaform = connect(state =>{
//     const es_actualizado = selector(state, 'es_actualizado')

//     let permiso_cuenta = true

//     if (!!es_actualizado == true){
//         permiso_cuenta = false
//     }
//     else{permiso_cuenta=true}

//     return{
//         permiso_cuenta
//     }
// })(ClientesForm)
